<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : '#000'" :class="[`${prefix}-icon`, `${prefix}-icon-push-service`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M42 8a2 2 0 012 2v28a2 2 0 01-2 2H24v-4h16V12H10v13H6V10a2 2 0 012-2h34zM19 36a1 1 0 011 1v2a1 1 0 01-1 1h-6a1 1 0 01-1-1v-2a1 1 0 011-1h6zm0-7a1 1 0 011 1v2a1 1 0 01-1 1H5a1 1 0 01-1-1v-2a1 1 0 011-1h14zm19.15-14.121a.5.5 0 01.492.41l.008.09v2.968a1 1 0 01-.35.76l-.1.075-12.707 8.37a.996.996 0 01-.633.162.992.992 0 01-.703-.15l-12.704-8.298a1 1 0 01-.453-.837v-3.046a.5.5 0 01.777-.416l12.991 8.628 13.107-8.633a.499.499 0 01.116-.057l.062-.016.097-.01z"/></svg>
</template>
<script>

export default {
  name: 'IconPushService',
  props: {
    prefix: {
        type: String,
        default: 'arco',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
